import classNames from 'classnames';
import React from 'react';
import styles from './tabs.css';
import { TextSmall } from './typography';

type Option<T> = {
  value: T;
  label: string;
};

type TabListProps<T> = {
  options: ReadonlyArray<Option<T>>;
  selectedValue: T;
  onChange: (value: T) => void;
};

export function TabList<T extends string>({
  options,
  selectedValue,
  onChange,
}: TabListProps<T>) {
  return (
    <div role="tablist" className={styles.tabList}>
      <div className={styles.tabListLine} />
      <div className={styles.tabListTabs}>
        {options.map(({ value, label }) => {
          const selected = selectedValue === value;
          return (
            <div
              key={value}
              className={classNames(
                styles.tabWrapper,
                selected && styles.selected,
              )}
            >
              <button
                role="tab"
                className={styles.tab}
                onClick={() => onChange(value)}
                aria-selected={selected}
              >
                <TextSmall tag="span">{label}</TextSmall>
              </button>
              <div
                className={classNames(
                  styles.tabLine,
                  selected && styles.selected,
                )}
              />
            </div>
          );
        })}
      </div>
    </div>
  );
}
